import { ClientEvent } from '@udemy/event-tracking';
export const COURSE_BADGE_BESTSELLER = 'bestseller';
export const COURSE_BADGE_FREE = 'free';
export const COURSE_BADGE_HIGHEST_RATED = 'top_rated';
export const COURSE_BADGE_HOT_AND_NEW = 'hot_and_new';
export const COURSE_BADGE_NEW = 'new';
export const COURSE_BADGE_UPDATED_RECENTLY = 'updated_recently';
export const COURSE_BADGE_CODING_EXERCISES = 'coding_exercises';

/** The possible types that a Course Badge can be */

/**
 * Provides additional properties
 * for any object that can be tracked
 */

/**
 * A minimal representation of a buyable, or purchasable, item
 * used for event tracking
 */

/**
 * Fired when user clicks the 'Enroll now' button
 */
class EnrollNowEvent extends ClientEvent {
  constructor({
    buyable
  }) {
    super('EnrollNowEvent');
    this.buyable = void 0;
    this.buyable = buyable;
  }
}

/**
 * Fired when quick view is viewed by a user
 */
class QuickViewBoxOpenEvent extends ClientEvent {
  constructor({
    id,
    type,
    trackingId
  }) {
    super('QuickViewBoxOpenEvent');
    this.id = void 0;
    this.type = void 0;
    this.trackingId = void 0;
    this.id = id;
    this.trackingId = trackingId;
    this.type = type;
  }
}

/* export events in alphabetical order*/
export { EnrollNowEvent, QuickViewBoxOpenEvent };
//# sourceMappingURL=events.js.map